import EquipmentReferenceIcon from './component'

export default EquipmentReferenceIcon
